import { workspaceAccountService } from "pages/app/workspace/services/account";
import { workspaceAthleteService } from "pages/app/workspace/services/athlete";
import { workspaceCommerceService } from "pages/app/workspace/services/commerce";
import { workspaceReferenceService } from "pages/app/workspace/services/reference";
import { workspaceSchoolService } from "pages/app/workspace/services/school";
import { workspaceSessionService } from "pages/app/workspace/services/session";

export const workspaceApi = {
  ...workspaceSessionService,
  ...workspaceAccountService,
  ...workspaceAthleteService,
  ...workspaceCommerceService,
  ...workspaceReferenceService,
  ...workspaceSchoolService,
};
